export default __webpack_public_path__ + "static/media/ic_box.a88e0422.svg";